export default "__VITE_ASSET__BqKuKOoN__"